import React from "react";
import ReactDOM from "react-dom";
import { PropTypes } from "prop-types";
import { InfiniteStoryBase, SocialShare, WithHostUrl, Link } from "@quintype/components";
import { get } from "lodash";
import { connect } from "react-redux";
import StoryHeader from "./story-templates/shared/story-header";
import StoryLock from "../../atoms/story-lock";
import StoryPremiumCard from "../../atoms/story-premium-card";
import SpecialBundleCard from "../../atoms/special-bundle-card";
import { STORY_TEMPLATES } from "../../../constants";
import { TextStory } from "./story-templates/text-story-page/feed-index";
import { PhotoAlbumStory } from "./story-templates/photo-album-story/feed-index";
import { VideoStory } from "./story-templates/video/feed-index";
import { PhotoStory } from "./story-templates/photo/feed-index";
import { ListicleStory } from "./story-templates/listicle-story/feed-index";
import { LongFormStory } from "./story-templates/long-form/feed-index";
import { ReviewStory } from "./story-templates/review/feed-index";
import { LiveBlogStory } from "./story-templates/live-blog/feed-index";
import { SocialShareTemplate } from "./story-templates/shared/social-share";
import Tags from "./story-templates/shared/tags";
import AuthorDetail from "./story-templates/shared/author-detail";
import Metype from "./story-templates/shared/metype";
import Vuukle from "./story-templates/shared/vuukle";
import VuukleCommentCount from "./story-templates/shared/vuukle/count";
import { generateHostStoryUrl } from "../../utils/generate-story-url";
import { DfpAd, refreshDfpAds } from "../../atoms/dfp-ad";
import {
  fetchRelatedStories,
  fetchLatestStories,
  fetchStoryAttributes,
  fetchWRUStories,
  triggerwruEvent
} from "../../../api";
import { hasStoryAccess, incrementPremiumStoriesRead } from "../../../paywall";
import { GA, ContentInsights, Chartbeat, Lotame, WebEngage, ComScore, DeepBI, LoadVuukle } from "../../../integrations";
import ErrorBoundary from "../../utils/error-boundary";
import { isPremium } from "../../../data/story";
import SecondaryMenu from "../../atoms/secondary-menu";
import StoryNewsletter from "../../atoms/story-newsletter";
import StoryExternalInternalAds from "../../atoms/story-external-internal-ad";
import { Icon } from "../../atoms/icon";
import Cookies from "universal-cookie";

import styles from "./styles.m.css";
import { removeBulletImagesFromStory } from "../../utils/utils";
import StorySecondaryCard from "./story-templates/shared/story-secondary-card";
const cookies = new Cookies();

function getStoryTemplateComponent(storyTemplate) {
  switch (storyTemplate) {
    case STORY_TEMPLATES.VIDEO:
      return VideoStory;
    case STORY_TEMPLATES.PHOTO:
      return PhotoStory;
    case STORY_TEMPLATES.PHOTO_ALBUM:
      return PhotoAlbumStory;
    case STORY_TEMPLATES.REVIEW:
      return ReviewStory;
    case STORY_TEMPLATES.LISTICLE:
      return ListicleStory;
    case STORY_TEMPLATES.LIVE_BLOG:
      return LiveBlogStory;
    case STORY_TEMPLATES.LONG_FORM:
      return LongFormStory;
    default:
      return TextStory;
  }
}

function storyPageFetchRelatedItems(currentHostUrl, story, cinemaMode) {
  return fetchRelatedStories(story).then(stories =>
    stories.filter(story => (cinemaMode ? story.url.startsWith(currentHostUrl) : true))
  );
}

function appendCustomQueryStringUrl(story) {
  return story;
}

class StoryTemplate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      relatedStories: [],
      access: null,
      socialView: false
    };
    this.floatingbar = React.createRef();
    this.handleClickView = this.handleClickView.bind(this);
  }

  componentDidMount() {
    if (typeof this.props.fetchRelatedStories === "function") {
      this.props
        .fetchRelatedStories(this.props.story)
        .then(relatedStories => {
          this.setState({ relatedStories });
        })
        .catch(console.error);
    }

    hasStoryAccess(this.props.story)
      .then(access => {
        this.setState({ access: access });
      })
      .catch(console.error);
  }

  handleClickView() {
    window.scrollTo({
      top: this.floatingbar.current.offsetTop - 120,
      behavior: "smooth"
    });
  }

  handleClickEvents(args) {
    GA.customEvent(args, this.props.story.id);
    DeepBI.customEvent(args, this.props.story.id);
  }

  render() {
    const story = removeBulletImagesFromStory(get(this.props, ["story"], null));
    if (!story) {
      return null;
    }
    const metypeConfig = get(this.props, ["metypeConfig"]);
    const config = get(this.props, ["config"]);
    const episodes = get(this.props, ["episodes"]);
    const versionStat = cookies.get("story_c");
    const renderSocialMedia = (className = "") => (
      <SocialShare
        className={className}
        template={SocialShareTemplate}
        fullUrl={story.url}
        title={story.headline}
        handleClickView={this.handleClickView}
        hashtags={
          story.tags &&
          story.tags
            .filter(tag => tag !== null)
            .map(tag => tag.name)
            .toString()
        }
        storyId={story.id}
      />
    );

    const renderHeaderCard = ({ className, readMore } = { className: "", readMore: false }) => (
      <StoryHeader
        // renderSocialMedia={renderSocialMedia}
        subheadline={false}
        config={config}
        story={story}
        className={`${className} js-story-header`}
        episodes={episodes}
        readMore={readMore}
      />
    );

    const renderSecondaryCard = ({ className } = { className: "" }) => (
      <StorySecondaryCard
        subheadline={false}
        config={config}
        story={story}
        className={`${className} js-story-header`}
        episodes={episodes}
      />
    );

    const renderTags = () => <Tags tags={story.tags} className={styles.tags} />;

    const renderAuthorDetails = () => (
      <AuthorDetail
        authors={story.authors}
        config={config}
        contributors={story.contributors}
        className={styles["author-detail"]}
      />
    );

    const renderReactions = () => {
      if (!metypeConfig) {
        return null;
      }
      return (
        <ErrorBoundary>
          <Metype id={story.id} metypeConfig={metypeConfig} type={"reaction"} pageURL={generateHostStoryUrl(story)} />
        </ErrorBoundary>
      );
    };

    const renderVuukleComments = () => {
      return <Vuukle story={story} vuukleConfig={LoadVuukle} login={this.props.config.vikatanHosts} />;
    };

    const renderComments = () => {
      if (!metypeConfig) {
        return null;
      }
      return (
        <Metype id={story.id} type={"comment"} metypeConfig={metypeConfig} pageURL={generateHostStoryUrl(story)} />
      );
    };

    const renderSidebar = () => (
      <aside className={styles.sidebar}>
        {!isPremium(this.props.story) && (
          <div className={`${styles["ad-wrapper"]} hidden-mobile`}>
            <DfpAd story={story} adtype="Rectangle" placement="story" id="story-sidebar-1" />
          </div>
        )}
        {!isPremium(this.props.story) && (
          <div className={`${styles["ad-halfpage"]} hidden-mobile`}>
            <DfpAd story={story} adtype="Half_Page" placement="story" id="story-sidebar-2" />
          </div>
        )}
      </aside>
    );

    const renderFooter = () => {
      return (
        <div className="js-story-footer">
          {!isPremium(this.props.story)}
          {(["METERING", "METERING LOCAL"].includes(get(this.state, ["access", "grantReason"])) ||
            (this.state.access && !get(this.state, ["access", "granted"]))) && (
            <StoryLock access={this.state.access} collectionId={get(this.props, ["issueCollection", "id"])} />
          )}
          {renderTags()}
          {!isPremium(this.props.story) && <DfpAd story={story} adtype="Small_Leaderboard" placement="story" />}
          <div ref={this.floatingbar}>{renderVuukleComments()}</div>
          {renderAuthorDetails()}
          <div className={styles["space-before-next-story"]} />
        </div>
      );
    };

    const renderPremiumCard = () => {
      return (
        <React.Fragment>
          {!isPremium(this.props.story)}
          {(["METERING", "METERING LOCAL"].includes(get(this.state, ["access", "grantReason"])) ||
            (this.state.access && !get(this.state, ["access", "granted"]))) && <StoryPremiumCard />}
        </React.Fragment>
      );
    };

    const renderfloatingBar = () => (
      <React.Fragment>
        <div className={"social-icons-div hidden-desktop"}>
          <div className="share-mb-div">
            <ul className={"mb-share"}>
              <li className="newsletter" onClick={this.handleClickView}>
                <a href="javascript:" onClick={this.handleClickEvents.bind(this, "comments")}>
                  <Icon type="newsletter" />
                </a>
              </li>
              <li className="share whatsapp">{renderSocialMedia()}</li>
              <li className="share" onClick={() => this.setState({ socialView: !this.state.socialView })}>
                <a href="JavaScript:">
                  {!this.state.socialView ? <Icon type="socialshare" /> : <Icon type="cancel" />}
                </a>
              </li>
            </ul>
          </div>
          {this.state.socialView && renderSocialMedia("show-mobile-and-tablet story-section")}
        </div>
      </React.Fragment>
    );

    const renderSocialMediaForMobile = props => {
      return (
        <React.Fragment>
          <div className={"hidden-desktop"}>
            <div className="mobile-view-socialmedia">
              <ul className="show-media-link">
                <li className="share whatsapp">{renderSocialMedia()}</li>
                <li className="share" onClick={() => this.setState({ socialView: !this.state.socialView })}>
                  <a
                    href="JavaScript:"
                    className="styles-m__social-share__link__vv6Ri styles-m__social-share__whatsapp-icon__-G7Vp"
                  >
                    {!this.state.socialView ? <Icon type="socialshare" /> : <Icon type="cancel" />}
                  </a>
                </li>
                <li className="newsletter" onClick={() => props.commentTriggerEvent()}>
                  <a
                    href="javascript:"
                    onClick={this.handleClickEvents.bind(this, "comments")}
                    className="styles-m__social-share__link__vv6Ri styles-m__social-share__whatsapp-icon__-G7Vp"
                  >
                    <Icon type="newsletter" />
                  </a>
                  <VuukleCommentCount mobileView={true} storyId={get(this.props, ["story", "id"], 0)} />
                </li>
              </ul>
            </div>
            {this.state.socialView && renderSocialMedia("show-mobile-and-tablet story-section")}
          </div>
        </React.Fragment>
      );
    };

    const renderProps = {
      renderSocialMedia,
      renderTags,
      renderAuthorDetails,
      renderReactions,
      renderComments,
      renderSidebar,
      renderHeaderCard,
      renderFooter,
      renderfloatingBar,
      renderSocialMediaForMobile,
      renderPremiumCard,
      renderSecondaryCard
    };

    const StoryTemplateComponent = getStoryTemplateComponent(story["story-template"]);
    return (
      <StoryTemplateComponent
        story={{
          ...story,
          cards: isPremium(story) && !get(this.state, ["access", "granted"], false) ? [] : story.cards
        }}
        config={config}
        episodes={episodes}
        {...renderProps}
        fireVirtualPageView={this.props.firePageView}
        READMORE_ENABLE={this.props.READMORE_ENABLE}
        relatedStories={this.state.relatedStories}
        checkInfoStatus={this.props.checkInfoStatus}
        versionStat={versionStat}
        index={this.props.index}
      />
    );
  }
}

export class StoryFeedPageBase extends React.Component {
  render() {
    const {
      story,
      fetchRelatedStories,
      episodes,
      config,
      metypeConfig,
      firePageView,
      issueCollection,
      READMORE_ENABLE,
      index,
      checkInfoStatus,
      versionStat,
      userType
    } = this.props;
    let readmoreStat = READMORE_ENABLE;

    if (index === 0) {
      readmoreStat = false;
    }
    return (
      <div className={`js-content-insights-${story.id}`}>
        <StoryTemplate
          story={story}
          config={config}
          fetchRelatedStories={fetchRelatedStories}
          episodes={episodes}
          metypeConfig={metypeConfig}
          firePageView={firePageView}
          issueCollection={issueCollection}
          READMORE_ENABLE={readmoreStat}
          checkInfoStatus={checkInfoStatus}
          versionStat={versionStat}
          index={index}
        />

        {userType === "P" || userType === "T" || userType === "R" ? (
          <div>
            {index % 5 === 0 &&
              index !== 0 && (
                <StoryNewsletter story={story} className={`${styles["newletter-wrapper"]} remove-margin`} />
              )}
          </div>
        ) : (
          <div>
            {index % 3 === 0 && index !== 0 ? (
              <div className={`${styles["ad-wrapper"]} margin-top`}>
                <DfpAd story={story} adtype="Rectangle" placement="story" className="hidden-desktop hidden-tablet" />
                <StoryExternalInternalAds story={story} className="remove-margin hidden-mobile" />
              </div>
            ) : index === 5 ? (
              <div>
                <StoryNewsletter story={story} className="remove-margin hidden-desktop" />
              </div>
            ) : (
              ""
            )}
          </div>
        )}
      </div>
    );
  }
}
StoryFeedPageBase.propTypes = {
  episodes: StoryHeader.propTypes.episodes,
  story: TextStory.propTypes.story,
  config: PropTypes.object,
  metypeConfig: PropTypes.object,
  fetchRelatedStories: PropTypes.func,
  firePageView: PropTypes.func,
  issueCollection: PropTypes.shape({
    id: PropTypes.number
  }),
  READMORE_ENABLE: PropTypes.bool,
  index: PropTypes.number,
  checkInfoStatus: PropTypes.func,
  versionStat: PropTypes.string,
  userType: PropTypes.string
};

class WrapperStoryIntersectionObserverBase extends React.Component {
  constructor(props) {
    super(props);
    this.storyRef = React.createRef();
  }

  componentDidMount() {
    this.intersectionObserver =
      global.IntersectionObserver &&
      new global.IntersectionObserver(
        entries => {
          // There will be only One target as we are implementing one Intersection Observer for every Story
          const story = this.props.story;
          if (entries[0].isIntersecting === true) {
            if (isPremium(story)) {
              hasStoryAccess(story).then(access => {
                if (access.granted && (access.grantReason === "METERING" || access.grantReason === "METERING LOCAL")) {
                  incrementPremiumStoriesRead(story.id);
                }
                access.remainingStoriesCount >= 0 &&
                  this.props.updateRemainingStoriesCounter(access.remainingStoriesCount);
              });
            }
            this.intersectionObserver && this.intersectionObserver.disconnect();
          }
        },
        {
          rootMargin: "0px"
        }
      );
    /* eslint-disable react/no-find-dom-node */
    this.intersectionObserver.observe(ReactDOM.findDOMNode(this.storyRef.current));
  }
  componentWillUnmount() {
    this.intersectionObserver && this.intersectionObserver.disconnect();
  }
  render() {
    return <StoryFeedPageBase {...this.props} ref={this.storyRef} />;
  }
}
// Dispatch the action to update the store from the Intersection Observer
const mapDispatchToProps = dispatch => {
  return {
    updateRemainingStoriesCounter: function(remainingStoriesCount) {
      dispatch({
        type: "UPDATE_STORIES_READ_STATS",
        remainingStoriesCount: remainingStoriesCount
      });
    }
  };
};
const WrapperStoryIntersectionObserver = connect(
  state => state,
  mapDispatchToProps
)(WrapperStoryIntersectionObserverBase);

const getStoriesByLabel = collection => {
  return collection.items.filter(({ story = {} }) => story.headline && story.url).reduce((storyMap, item) => {
    const label = get(item, ["associated-metadata", "label"], "மற்றவை");
    if (storyMap[label]) {
      storyMap[label].push(item.story);
    } else {
      storyMap[label] = [item.story];
    }
    return storyMap;
  }, {});
};

const generateSecondaryMenu = (issueCollection, magazine) => {
  const storyMap = issueCollection && getStoriesByLabel(issueCollection);
  const rootMenuGroup = Object.keys(storyMap).map((label, idx) => {
    return {
      title: label,
      id: idx,
      items: storyMap[label].map(storyObject => {
        return {
          title: storyObject["headline"],
          url: storyObject["url"]
        };
      })
    };
  });

  const firstElement = magazine.name && (
    <Link href={issueCollection.pagePath} className={styles["magazine-name"]}>
      {magazine.name.replace(/\(\w+\)/, "")}
    </Link>
  );
  const root = {
    items: rootMenuGroup
  };
  return (
    <SecondaryMenu
      menuGroup={root}
      className={styles["magazine-secondary"]}
      firstElement={firstElement}
      communityColor={magazine.color}
    />
  );
};

export class StoryFeedPage extends React.Component {
  constructor(props) {
    super(props);
    this.firePageView = this.firePageView.bind(this);
    this.cachedFirstPageStories = [];
    this.MAX_ALREADY_STORIES_READ_COUNT = 20;
    this.state = { READMORE_ENABLE: false, visibleStories: [], userType: "F" };
    this.checkInfoStatus = this.checkInfoStatus.bind(this);
  }

  isStoryNotReadYet(storyId) {
    if (!global.localStorage) {
      return true;
    }

    const alreadyReadStories = JSON.parse(global.localStorage.getItem("alreadyReadStories") || "[]");
    return !alreadyReadStories.includes(storyId);
  }

  markStoryAsRead(storyId) {
    if (!global.localStorage) {
      return null;
    }
    let alreadyReadStories = JSON.parse(global.localStorage.getItem("alreadyReadStories") || "[]");
    if (alreadyReadStories.length >= this.MAX_ALREADY_STORIES_READ_COUNT) {
      alreadyReadStories = [];
    }
    let alreadyReadStoriesSet = new Set(alreadyReadStories);
    alreadyReadStoriesSet.add(storyId);
    global.localStorage.setItem("alreadyReadStories", JSON.stringify(Array.from(alreadyReadStoriesSet)));
  }

  storyPageLoadItems(currentHostUrl, pageNumber, collectionMapping) {
    const current = new Date();
    const nextWeek = new Date();
    nextWeek.setDate(current.getDate() + 28);
    let NUMBER_OF_STORIES_PER_PAGE = 20;
    let limit =
      this.MAX_ALREADY_STORIES_READ_COUNT / NUMBER_OF_STORIES_PER_PAGE > pageNumber + 1
        ? this.MAX_ALREADY_STORIES_READ_COUNT
        : 20;

    let storiesPromise = Promise.resolve(this.cachedFirstPageStories);
    const story = cookies.get("story-view");
    if (
      !this.cachedFirstPageStories.length ||
      this.MAX_ALREADY_STORIES_READ_COUNT / NUMBER_OF_STORIES_PER_PAGE < pageNumber + 1
    ) {
      return fetchWRUStories(pageNumber, limit, cookies.get("thinmint"), story.id)
        .then(response => {
          return response ? response.map(res => res !== null && { story: appendCustomQueryStringUrl(res.story) }) : [];
        })
        .then(async response => {
          if (response.length === 0) {
            cookies.set("story_c", "v2", { domain: ".vikatan.com", expires: nextWeek, path: "/" });
            let latestStories = await fetchLatestStories(pageNumber, limit);
            return latestStories.stories
              ? latestStories.stories.map(story => ({ story: appendCustomQueryStringUrl(story) }))
              : [];
          } else {
            return response;
          }
        })
        .then(stories => {
          this.cachedFirstPageStories = stories;
          const storiesAfterFiltering = stories.filter(({ story }) => this.isStoryNotReadYet(story.id));
          if (!storiesAfterFiltering.length) {
            return stories.slice(0, NUMBER_OF_STORIES_PER_PAGE);
          }
          // if false means Disabled all Read more option
          this.setState({
            READMORE_ENABLE: true
          });
          return storiesAfterFiltering.slice(0, NUMBER_OF_STORIES_PER_PAGE);
        });
    } else {
      return storiesPromise;
    }
  }

  componentDidMount() {
    const current = new Date();
    const nextWeek = new Date();
    nextWeek.setDate(current.getDate() + 28);
    const story = get(this.props, ["data", "story"], {});
    cookies.set("story-view", { id: story.id, headline: story.headline });
    cookies.set("story_c", "v3", { domain: ".vikatan.com", expires: nextWeek, path: "/" });
    this.markStoryAsRead(story.id);
    this.firePageView();
    triggerwruEvent(story.id, cookies.get("thinmint"), "STORY_VIEW_EVENT");
    const collectionMapping = get(this.props, ["config", "collectionMapping"], null);
    this.storyPageLoadItems(story.url, 0, collectionMapping);
    global.userPromise.catch(() => ({})).then(user => {
      this.setState({ userType: user.userType });
    });
    this.timer = setInterval(() => {
      refreshDfpAds("story-sidebar-1");
      refreshDfpAds("story-sidebar-2");
      refreshDfpAds("tower-right-1");
      refreshDfpAds("tower-left-1");
    }, 20000);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  firePageView(story = this.props.data.story, firedFromInfinite = false) {
    if (this.props.config.disableAds) {
      return;
    }
    LoadVuukle.register(story, this.props.config.vikatanHosts);
    const metypeConfig = get(this.props, ["data", "publisherConfig", "metypeConfig"]);
    const contentInsightsId = get(this.props, ["data", "publisherConfig", "contentInsightsId"]);
    const issueCollection = get(this.props, ["data", "issueCollection"], null);
    Chartbeat.registerPageView(story);
    ContentInsights.registerPageView(contentInsightsId, story, metypeConfig);
    Lotame.registerPageView({ story });
    WebEngage.registerPageView({ story });
    ComScore.registerPageView();
    fetchStoryAttributes(story)
      .then(result => {
        GA.registerPageView(this.props.pageType, {
          story: { ...story, collections: result.collections },
          collection: issueCollection,
          infiniteTagRequired: firedFromInfinite
        });
        DeepBI.registerPageView({ story: { ...story, collections: result.collections } });
        hasStoryAccess(story).then(access => {
          if (!access.granted && (access.grantReason === "METERING" || access.grantReason === "METERING LOCAL")) {
            DeepBI.paywallStory(story, issueCollection);
          }
        });
      })
      .catch(console.error);
  }

  checkInfoStatus = stat => {
    const story = get(this.props, ["data", "story"]);
    if (stat.status === true) {
      this.sendQlitics(story);
      this.setState({
        visibleStories: [...this.state.visibleStories, stat.id]
      });
    } else {
      let filteredArray = this.state.visibleStories.filter(item => item !== stat.id);
      this.setState({
        visibleStories: filteredArray
      });
    }
  };

  sendQlitics = (story = {}) => {
    const { registerStoryView } = require("@quintype/framework/client/analytics");
    registerStoryView(story.id);
  };

  render() {
    const metypeConfig = get(this.props, ["data", "publisherConfig", "metypeConfig"]);
    const collectionMapping = get(this.props, ["config", "collectionMapping"], null);
    const issueCollection = get(this.props, ["data", "issueCollection"]);
    const magazineEntity = get(this.props, ["data", "magazineEntity"]);
    const cinemaMode = get(this.props, ["config", "cinemaMode"]);
    const story = get(this.props, ["data", "story"]);
    const { visibleStories, userType } = this.state;
    return (
      <React.Fragment>
        {issueCollection &&
          magazineEntity && (
            <div className={styles["secondary-menu"]}>{generateSecondaryMenu(issueCollection, magazineEntity)}</div>
          )}

        <div className={`main-page styles-m__base__2vtxy js-story-main-container`}>
          <DfpAd
            className="hidden-mobile ad-tower-left"
            adtype="Tower_Left"
            placement="storyfeed"
            slotId="tower-left-1"
          />

          <div className="page-content infinity-page">
            <div className={`container ${styles["story-grid"]}`}>
              <div className={styles["main-content"]}>
                <WithHostUrl>
                  {({ currentHostUrl }) => (
                    <InfiniteStoryBase
                      {...this.props}
                      render={storyProps => (
                        <WrapperStoryIntersectionObserver
                          {...Object.assign({}, storyProps)}
                          config={this.props.config}
                          metypeConfig={metypeConfig}
                          fetchRelatedStories={story => storyPageFetchRelatedItems(currentHostUrl, story, cinemaMode)}
                          firePageView={() => this.firePageView(storyProps.story)}
                          READMORE_ENABLE={this.state.READMORE_ENABLE}
                          checkInfoStatus={this.checkInfoStatus}
                          versionStat={this.props.versionStat}
                          userType={userType}
                        />
                      )}
                      loadItems={pageNumber => this.storyPageLoadItems(currentHostUrl, pageNumber, collectionMapping)}
                      onInitialItemFocus={(item, key) => {
                        if (item.story && item.story.id) {
                          this.markStoryAsRead(item.story.id);
                          if (key === "1") {
                            this.firePageView(item.story, true);
                          }
                        }
                      }}
                      onItemFocus={(item, key) => {
                        const stortId = get(item, ["story", "id"]);
                        const versionStat = cookies.get("story_c");
                        const storyUrlView = visibleStories.indexOf(stortId);
                        if (storyUrlView !== -1) {
                          global.app.maybeSetUrl(
                            "/" + item.story.slug + "?artfrm=" + versionStat,
                            get(item, ["story", "seo", "meta-title"], item.story.headline)
                          );
                        } else if (key === "0") {
                          global.app.maybeSetUrl(
                            "/" + item.story.slug,
                            get(item, ["story", "seo", "meta-title"], item.story.headline)
                          );
                        } else {
                          global.app.maybeSetUrl("/story-feed", "Vikatan Feed", "Vikatan Feed");
                        }
                      }}
                      neverHideItem={true}
                      doNotChangeUrl={true}
                    />
                  )}
                </WithHostUrl>
              </div>
              <aside className={styles.sidebar}>
                {!isPremium(story) && (
                  <div className={`${styles["ad-wrapper"]} hidden-mobile`}>
                    <DfpAd story={story} adtype="Rectangle" placement="story" slotId="story-sidebar-1" />
                  </div>
                )}
                {!isPremium(this.props.story) && (
                  <div className={`${styles["ad-halfpage"]} hidden-mobile`}>
                    {userType === "P" || userType === "T" || userType === "R" ? (
                      <SpecialBundleCard className="feed-page" />
                    ) : (
                      <DfpAd story={story} adtype="Half_Page" placement="story" slotId="story-sidebar-2" />
                    )}
                  </div>
                )}
              </aside>
            </div>
          </div>

          <DfpAd
            className="hidden-mobile ad-tower-right"
            adtype="Tower_Right"
            placement="storyfeed"
            slotId="tower-right-1"
          />
        </div>
      </React.Fragment>
    );
  }
}
